const Footer = () => {
    return (
        <footer className="footer mt-auto py-3 bg-dark">
            <div className="container">
                <p className="text-light">App developed by <a href="https://www.linkedin.com/in/viviane-l-a84bab55/" target="_blank" rel="noreferrer">Viviane Lara</a></p>
                <p className="text-light"><small><strong>Spring React Week</strong><br />
            Event promoted by DevSuperior school: <a href="https://instagram.com/devsuperior.ig" target="_blank" rel="noreferrer">@devsuperior.ig</a></small></p>
            </div>
        </footer>
    );
}

export default Footer;